import React from 'react'
import { Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  contentBox: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      marginTop: '1.5rem'
    }
  },
  edgeBox: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    },
    maxWidth: '8%',
    minWidth: '8%'
  },
  innerBox: {
    paddingLeft: '2rem',
    paddingRight: '2rem',
    paddingTop: '1rem',
    [theme.breakpoints.up('md')]: {
      padding: '0rem'
    }
  }
}))

export const ContentContainer = (
  props: React.PropsWithChildren<React.ReactNode>
) => {
  const classes = useStyles()

  return (
    <Box
      className={classes.contentBox}
      display="flex"
      flexGrow={1}
      flexShrink={0}
      justifyContent="center"
    >
      <Box className={classes.edgeBox} flexGrow={1} flexShrink={1}></Box>
      <Box className={classes.innerBox} flexGrow={1} flexShrink={1}>
        {props.children}
      </Box>
      <Box className={classes.edgeBox} flexGrow={1} flexShrink={1}></Box>
    </Box>
  )
}
